import React__default from 'react';
import { useTheme, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-byfklTA-.js';
import { S as StormContextProvider } from '../StormContext/StormContextProvider-BTxpbm54.js';
import { C as ConfigObserver } from './ConfigObserver-xpKlUycK.js';
import { u as useEffectiveTheme } from './hooks/useThemeMode/useEffectiveTheme-Bjw-8scc.js';

/**
 * Validates if the provided object is a valid theme (non-empty object) or theme function.
 * Prevents empty objects from being used as themes in JavaScript applications.
 */
const isValidTheme = obj => {
  if (typeof obj === 'function') return true;
  if (!obj || typeof obj !== 'object') return false;
  return Object.keys(obj).length > 0;
};

/**
 * Checks if the theme is a valid v4 Storm UI theme.
 * Prevents incompatible themes from older versions being used as parent themes.
 */
const isV4Theme = obj => !!obj && typeof obj === 'object' && obj.version === 4;
const ThemeProvider = ({
  children,
  theme,
  enableThemeModes = false
}) => {
  const parentTheme = /*#__PURE__*/useTheme();
  const dynamicTheme = useEffectiveTheme(enableThemeModes);

  // Resolve theme in priority order
  const fallbackTheme = (isV4Theme(parentTheme) ? parentTheme : null) || dynamicTheme || stormLightTheme;
  let resolvedTheme = fallbackTheme;
  if (isValidTheme(theme)) {
    resolvedTheme = typeof theme === 'function' ? theme(fallbackTheme) : theme;
  }
  return /*#__PURE__*/React__default.createElement(ConfigObserver, null, config => /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: resolvedTheme
  }, /*#__PURE__*/React__default.createElement(StormContextProvider, null, children)));
};

export { ThemeProvider as T };
//# sourceMappingURL=ThemeProvider-Ba4PQhSR.js.map
